import React from "react";

import {Button, Col, Row} from "reactstrap";

import * as courseService from "../../../services/courses";
import NotFound from "../../../components/NotFound/NotFound";
import {lang, language} from "../../../const/language";
import Container from "react-bootstrap/Container";
import * as constants from "../../../const/constants";
import moment from "moment";
import * as commonFunc from "../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";


class ViewPurchasedCourses extends React.Component {
    state = {
        course: [],
        boughtCourses: [],
        lessonToCourse: []
    };

    async componentDidMount() {
        await this.fetchInstituteCourses();

    }

    fetchInstituteCourses = async () => {

        await courseService.getInstituteCourses().then(
            res => {
                if (res.success) {
                    this.setState({
                        courses: res.body
                    });
                    console.log(res);
                    this.getPurchasedCourses(res);
                } else {
                    this.setState({
                        viewCourse: false
                    });
                }

            }
        )
    };

    getPurchasedCourses = async (courses) => {
        console.log(courses.body);
        let allCourses = courses.body;
        console.log(allCourses);
        let bCourses = [];

        allCourses.map((course, index) => {
            if (course.buttonStatus != 'BUY') {
                this.state.boughtCourses.push(course);
                console.log(course);
                bCourses.push(course);
            }

        });
        console.log(bCourses.length);
        await this.setState({boughtCourses: bCourses})
    };

    viewCourse = (courseId, courseDTO) => {
        let courseProps = {
            courseId: courseId,
            courseDetails: courseDTO,
            userType: 1
        };

        console.log(courseProps);
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
            state: courseProps
        })
    };

    viewResources = async (course) => {
        console.log(this.props);
        commonFunc.viewClassResources(this.props, course);
    };

    joinClass = (course) => {
        let obj = {
            id: course.courseId,
            name: course.name
        };
        console.log(this.props);
        commonFunc.joinCourseHandler(this.props, obj).then(r => {
            console.log(r)
        })
    };
    viewCoursePapers = (course) => {
        let isClass = false;
        console.log(this.props);
        commonFunc.viewPaperResources(this.props, course.courseId, isClass);
    };

    render() {
        console.log(this.state.boughtCourses.length === 0 ? 'Empty Still' : this.state.boughtCourses);
        let course = this.state.boughtCourses;
        console.log(course);
        return (
            course !== undefined &&
            <Container>

                {
                    this.state.boughtCourses.length === 0 &&
                    <NotFound/>
                }
                {this.state.boughtCourses.map((course, index) =>
                    <Row key={index} className={`view-class row shadow `}>
                        <Col md={12} lg={3}>
                            <div className={"vc-image-wrapper"}>
                                <img className={"vc-blur-image"} src={course.imageUrl} alt={"class"}/>
                                <img className={"vc-image"} src={course.imageUrl} alt={"class"}/>
                            </div>
                        </Col>

                        <Col md={12} lg={6}>
                            <div className={"vc-right"}>
                                <p className={"vc-topic"}>{course.name}</p>
                                {
                                    (course.nextDayOfCourseSession !== undefined && course.nextDayOfCourseSession !== null) &&
                                    <p className={"vc-next"}>{`${language[lang].NextClassIsOn} ${moment(course.nextDayOfCourseSession.replace("Z", "")).format("DD MMM YYYY")} at ${moment(course.nextDayOfCourseSession.replace("Z", "")).format("h:mm A")}`}</p>
                                }

                                <div style={{backgroundColor: '#b4c3ca', marginBottom: '3%', borderRadius: '10px'}}>
                                    {
                                        course.coursesDayTimes.length !== 0 ? course.coursesDayTimes.map((dayTime, i) => (
                                                <ul key={index} className={"card-cont day-list"}>
                                                    <li>
                                                        <p
                                                            key={i}>{`${language[lang][dayTime.day]}:`}</p>
                                                        <p>

                                                            {`${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm a')} to ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm a')}`}
                                                        </p>
                                                    </li>
                                                </ul>)) :
                                            <ul className={"card-cont day-list"}>
                                                <p>-</p>
                                                <p>-</p>
                                            </ul>
                                    }
                                </div>
                                {/*{*/}
                                {/*    dayTimes !== 0 && dayTimes.map((dayTime, i) => (*/}
                                {/*        <p className={"vc-day"}*/}
                                {/*           key={i}>{`${language[lang][dayTime.day]}, ${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm A')} to ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm A')}`}</p>*/}
                                {/*    ))*/}
                                {/*}*/}

                                {/*{*/}
                                {/*    course.courseInstallmentList.length !== 0 ?*/}
                                {/*        <div className={"enrolled-months"}>*/}
                                {/*            <p className={"title"}>{language[lang].PurchaseMonths}</p>*/}
                                {/*            { course.courseInstallmentList.map((installment, index) => (*/}
                                {/*                <li key={index}*/}
                                {/*                    className={"text syllabus"}>index</li>*/}
                                {/*            ))}*/}
                                {/*        </div> :*/}
                                {/*        <div className={"enrolled-months"}>*/}
                                {/*            <p className={"title mt-2 mb-2"}>{language[lang].FreeCard}</p>*/}
                                {/*        </div>*/}
                                {/*}*/}

                                {/*{*/}
                                {/*    ((nextDayOfClass !== undefined && nextDayOfClass !== null) && buttonStatus !== constants.BOUGHT_TEXT) &&*/}
                                {/*    <Button className="btn-neutral normal-txt vc-mb-1" color="default"*/}
                                {/*            onClick={this.purchaseHandler}>*/}
                                {/*        {`Purchase for ${moment(nextDayOfClass.replace("Z","")).format("MMM")} - LKR ${parseFloat(fee).toFixed(2)}`}*/}
                                {/*    </Button>*/}
                                {/*}*/}
                            </div>
                        </Col>

                        <Col md={12} lg={3} className="pb-3">
                            <div className={"vc-action mt-3"}>
                                <Button className="com-btn log-btn normal-txt mb-1" color="default" onClick={() => {
                                    this.props.history.push({
                                        pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                                        state: {id: course.courseId}
                                    })
                                    // this.viewCourse(course.courseId, course)
                                }}>
                                    {language[lang].viewCourseDetails}
                                </Button>

                                {
                                    <Button className="com-btn log-btn normal-txt mb-1" color="default"
                                            onClick={() => {
                                                this.joinClass(course)
                                            }}
                                    >
                                        {language[lang].JoinTheClass}
                                    </Button>
                                }


                                {

                                    <Button className="com-btn log-btn normal-txt mb-1" color="default"
                                            onClick={() => {
                                                this.viewResources(course)
                                            }}>
                                        {language[lang].ClassResources}
                                    </Button>
                                }
                                {course.quizAvailable ?

                                    <Button
                                        onClick={() => this.viewCoursePapers(course)}
                                        className="com-btn  ">{language[lang].QuizesAndTestPapers}</Button> : null
                                }
                                {/*{*/}

                                {/*    <Button className="com-btn log-btn normal-txt" color="default"  >*/}
                                {/*        {language[lang].QuizesAndTestPapers}*/}
                                {/*    </Button>*/}
                                {/*}*/}
                            </div>
                        </Col>

                    </Row>
                )}

            </Container>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});
export default connect('', mapDispatchToProps)(withRouter(ViewPurchasedCourses));
// export default ViewPurchasedCourses;